import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { obtenerUtilidadLiquidacionesAction } from "../../../ducks/reportesDuck"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import { makeStyles } from '@material-ui/core/styles';
import { formatDinero } from "./../../../utils/formatDinero"
import { Card, CardContent, Grid, Typography } from "@material-ui/core";
import PickerMod from "../../../global/PickersMod"
import { FormatoFecha, esFechaValida } from "../../../utils/FormatFecha";
import Grafica from "./Grafica";
const useStyles = makeStyles({
    main: {
        padding: "2%"
    },
    container: {
        display: "flex",
        flexFlow: "row",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "1rem",
    },
    root: {
        width: '60%',
        minWidth: 180,
        height: 460,
        marginTop: "1rem"
    },
    rootGrafica: {
        width: '40%',
        minWidth: 180,
        height: 460,
        marginTop: "1rem"
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 10,
        marginTop: 10,
        padding: 2
    },
});
const calUtilidad = ({ utilidadPaquete, utlidadCorte, utlidadSobrante, utilidadBaja }) => {
    return utilidadPaquete + utlidadCorte + utlidadSobrante + utilidadBaja
}
const calItems = ({ reserva, aereros, liquidacion, utilidad }) => {
    return reserva + aereros + liquidacion + utilidad
}
const calProevedor = ({ reserva, aereros, liquidacion }) => {
    return reserva + aereros + liquidacion
}
const calcularProcentaje = ({ monto, total }) => {
    let resultado = monto * 100
    resultado = resultado / total
    return (resultado < 0) ? resultado * -1 : resultado
}
const useObtenerUtilidadGrupal = ({ fechaInicio, fechaFinal }) => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "Obteniendo información..." }))
        dispatch(obtenerUtilidadLiquidacionesAction({ FechaFin: FormatoFecha({ date: fechaFinal, formato: "MMddyyyy" }), FechaIni: FormatoFecha({ date: fechaInicio, formato: "MMddyyyy" }) })).then(Resposne => {
            dispatch(offLoadAction())
        })
    }, [dispatch, fechaInicio, fechaFinal])
}
const Utilidad = () => {
    const classes = useStyles()
    const { utilidadLiquidaciones } = useSelector(store => store.reportes)
    const [selectDayInicio, setSelectedDateInicio] = useState(new Date())
    const [selectDayFin, setSelectedDateFin] = useState(new Date())
    const handleChangeFechaIncio = (date) => {
        if (!esFechaValida({date})) {
            return null
        }
        setSelectedDateInicio(date) 
    }
    const handleChangeFechaFin = (date) => {
        if (!esFechaValida({date})) {
            return null
        }
        setSelectedDateFin(date) 
    }
    useObtenerUtilidadGrupal({ fechaFinal: selectDayFin, fechaInicio: selectDayInicio })
    const totalUtilidadMXN = calUtilidad({ utilidadPaquete: utilidadLiquidaciones.MontoUtilPaqueteMXN, utlidadCorte: 0, utlidadSobrante: utilidadLiquidaciones.MontoUtilSobranteMXN, utilidadBaja:  utilidadLiquidaciones.MontoUtilSuspendidaMXN})
    const totalUtilidadUSD = calUtilidad({ utilidadPaquete: utilidadLiquidaciones.MontoUtilPaqueteUSD, utlidadCorte: utilidadLiquidaciones.MontoUtilTipoCambio, utlidadSobrante: utilidadLiquidaciones.MontoUtilSobranteUSD,utilidadBaja: utilidadLiquidaciones.MontoUtilSuspendidaUSD})
    const totalItemsMXN = calItems({ reserva: utilidadLiquidaciones.MontoReservaMXN, aereros: utilidadLiquidaciones.MontoAereoMXN, liquidacion: utilidadLiquidaciones.MontoLiquidacionMXN, utilidad: totalUtilidadMXN })
    const totalItemsUSD = calItems({ reserva: utilidadLiquidaciones.MontoReservaUSD, aereros: utilidadLiquidaciones.MontoAereoUSD, liquidacion: utilidadLiquidaciones.MontoLiquidacionUSD, utilidad: totalUtilidadUSD })
    const totalProveedorMXN = calProevedor({reserva: utilidadLiquidaciones.MontoReservaMXN, aereros: utilidadLiquidaciones.MontoAereoMXN, liquidacion: utilidadLiquidaciones.MontoLiquidacionMXN })
    const totalProveedorUSD = calProevedor({ reserva: utilidadLiquidaciones.MontoReservaUSD, aereros: utilidadLiquidaciones.MontoAereoUSD, liquidacion: utilidadLiquidaciones.MontoLiquidacionUSD })
    return (
        <div className={classes.main}>
            <Grid container>
                {/* <Grid item xs={12}>
                    fechaIncio {FormatoFecha({ date: selectDayInicio, formato: "MMddyyyy" })}
                    <br />
                    fechaFinal {FormatoFecha({ date: selectDayFin, formato: "MMddyyyy" })}
                </Grid> */}
                <Grid item xs={4}>
                    <PickerMod
                        id="fechaIncioutilidadLiquidaciones"
                        label="Fecha Inicio"
                        selectedDate={selectDayInicio}
                        setSelectedDate={handleChangeFechaIncio}
                        disablePast={false}
                        disableFuture={true}
                    />
                </Grid>
                <Grid item xs={4}>
                    <PickerMod
                        id="fechaFinalutilidadLiquidaciones"
                        label="Fecha Final"
                        selectedDate={selectDayFin}
                        setSelectedDate={handleChangeFechaFin}
                        disablePast={false}
                        disableFuture={true}
                    />
                </Grid>
            </Grid>
            <div className={classes.container}>
                <Card className={classes.root}>
                    <CardContent>
                        <Grid container>
                            <Grid item xs={12}>
                                <div style={{ marginBottom: "1rem" }}>
                                    <Typography color="textSecondary" variant="h6" >
                                        Resumen en USD
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ marginBottom: "1rem" }}>
                                    <Typography color="textSecondary" variant="subtitle2">
                                        Total de pasajeros: {utilidadLiquidaciones.TotalPasajerosUSD}
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid item xs={12} >
                                <div style={{ marginBottom: "1rem" }}>
                                    <Grid container>
                                        <Grid item xs={4}>
                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Monto reserva:
                                                </Typography>
                                                <Typography color="textPrimary" >
                                                    {`${formatDinero(utilidadLiquidaciones.MontoReservaUSD)} USD`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos}>
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Monto aereos:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(utilidadLiquidaciones.MontoAereoUSD)} USD`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos}>
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Monto liquidacion:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(utilidadLiquidaciones.MontoLiquidacionUSD)} USD`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos}>
                                                <Typography color="textSecondary" variant="subtitle2">
                                                   Total proveedor: 
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(totalProveedorUSD)} USD`}
                                                </Typography>
                                            </div>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Utilidad paquete:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(utilidadLiquidaciones.MontoUtilPaqueteUSD)} USD`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Utilidad sobrante:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(utilidadLiquidaciones.MontoUtilSobranteUSD)} USD`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Utilidad tipo de cambio:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(utilidadLiquidaciones.MontoUtilTipoCambio)} USD`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Utilidad por baja:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(utilidadLiquidaciones.MontoUtilSuspendidaUSD)} USD`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Utilidad total:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(utilidadLiquidaciones.MontoUtilPaqueteUSD + utilidadLiquidaciones.MontoUtilSobranteUSD + utilidadLiquidaciones.MontoUtilTipoCambio + utilidadLiquidaciones.MontoUtilSuspendidaUSD)} USD`}
                                                </Typography>
                                            </div>
                                        </Grid>
                                        <Grid item xs={4}>
                                        
                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Suma total:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(totalItemsUSD)} USD`}
                                                </Typography>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Card className={classes.rootGrafica}>
                    <CardContent>
                        <Grid container>
                            {/* <Grid item xs={12}>
                                <div style={{ marginBottom: "1rem" }}>
                                    <Typography color="textSecondary" variant="h6" >
                                        Resumen en USD
                                    </Typography>
                                </div>
                            </Grid> */}
                            <Grid item xs={12} >
                                <div style={{ marginBottom: "1rem" }}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Grafica
                                                label="%"
                                                labels={['Reservas', 'Aereos', 'Liquidaciones', 'Utilidad']}
                                                valores={[
                                                    calcularProcentaje({ monto: utilidadLiquidaciones.MontoReservaUSD, total: totalItemsUSD }),
                                                    calcularProcentaje({ monto: utilidadLiquidaciones.MontoAereoUSD, total: totalItemsUSD }),
                                                    calcularProcentaje({ monto: utilidadLiquidaciones.MontoLiquidacionUSD, total: totalItemsUSD }),
                                                    calcularProcentaje({ monto: totalUtilidadUSD, total: totalItemsUSD }),
                                                ]}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </div>
            <div className={classes.container}>
                <Card className={classes.root}>
                    <CardContent>
                        <Grid container>
                            <Grid item xs={12}>
                                <div style={{ marginBottom: "1rem" }}>
                                    <Typography color="textSecondary" variant="h6" >
                                        Resumen en MXN
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ marginBottom: "1rem" }}>
                                    <Typography color="textSecondary" variant="subtitle2">
                                        Total de pasajeros: {utilidadLiquidaciones.TotalPasajerosMXN}
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid item xs={12} >
                                <div style={{ marginBottom: "1rem" }}>
                                    <Grid container>
                                        <Grid item xs={4}>
                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Monto reserva:
                                                </Typography>
                                                <Typography color="textPrimary" >
                                                    {`${formatDinero(utilidadLiquidaciones.MontoReservaMXN)} MXN`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos}>
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Monto aereos:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(utilidadLiquidaciones.MontoAereoMXN)} MXN`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos}>
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Monto liquidacion:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(utilidadLiquidaciones.MontoLiquidacionMXN)} MXN`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos}>
                                                <Typography color="textSecondary" variant="subtitle2">
                                                  Total proveedor
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(totalProveedorMXN)} MXN`}
                                                </Typography>
                                            </div>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Utilidad paquete:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(utilidadLiquidaciones.MontoUtilPaqueteMXN)} MXN`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Utilidad sobrante:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(utilidadLiquidaciones.MontoUtilSobranteMXN)} MXN`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Utilidad tipo de cambio:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`NO APLICA`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Utilidad por baja:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(utilidadLiquidaciones.MontoUtilSuspendidaMXN)} MXN`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Utilidad total:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(utilidadLiquidaciones.MontoUtilPaqueteMXN + utilidadLiquidaciones.MontoUtilSobranteMXN + utilidadLiquidaciones.MontoUtilSuspendidaMXN)} MXN`}
                                                </Typography>
                                            </div>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Suma total:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(totalItemsMXN)} MXN`}
                                                </Typography>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Card className={classes.rootGrafica}>
                    <CardContent>
                        <Grid container>
                            {/* <Grid item xs={12}>
                                <div style={{ marginBottom: "1rem" }}>
                                    <Typography color="textSecondary" variant="h6" >
                                        Resumen en MXN
                                    </Typography>
                                </div>
                            </Grid> */}
                            <Grid item xs={12} >
                                <div style={{ marginBottom: "1rem" }}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Grafica
                                                label="%"
                                                labels={['Reservas', 'Aereos', 'Liquidaciones', 'Utilidad']}
                                                valores={[
                                                    calcularProcentaje({ monto: utilidadLiquidaciones.MontoReservaMXN, total: totalItemsMXN }),
                                                    calcularProcentaje({ monto: utilidadLiquidaciones.MontoAereoMXN, total: totalItemsMXN }),
                                                    calcularProcentaje({ monto: utilidadLiquidaciones.MontoLiquidacionMXN, total: totalItemsMXN }),
                                                    calcularProcentaje({ monto: totalUtilidadMXN, total: totalItemsMXN }),
                                                ]}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </div>
        </div>
    )
}
export default Utilidad
